import React from 'react';
import { motion, HTMLMotionProps } from 'framer-motion';
interface CardProps extends HTMLMotionProps<'div'> {
  children: React.ReactNode;
  noPadding?: boolean;
  hoverEffect?: boolean;
}
export function Card({
  children,
  className = '',
  noPadding = false,
  hoverEffect = false,
  ...props
}: CardProps) {
  return <motion.div className={`
        bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden
        ${hoverEffect ? 'hover:shadow-md transition-shadow duration-300' : ''}
        ${className}
      `} {...props} data-id="element-216">
      <div className={noPadding ? '' : 'p-6'} data-id="element-217">{children}</div>
    </motion.div>;
}